import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import SEOHead from "@/components/SEOHead";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEOHead
        title="Privatlivspolitik | MySabbat"
        description="Læs MySabbats privatlivspolitik. Vi beskytter dine persondata i overensstemmelse med GDPR og dansk lovgivning."
        path="/privacy"
      />
      <Header />

      {/* Content */}
      <main className="flex-1 py-12 md:py-20">
        <div className="container">
          {/* Back button */}
          <div className="max-w-2xl mx-auto mb-8">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary/10 text-primary hover:bg-primary/20 transition-colors font-medium text-sm"
            >
              <ChevronLeft className="w-4 h-4" />
              Tilbage til forsiden
            </Link>
          </div>

          <article className="max-w-2xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-semibold text-foreground mb-2">
              Privatlivspolitik for MySabbat
            </h1>
            <p className="text-muted-foreground mb-10">
              Senest opdateret: {new Date().toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: 'numeric' })}
            </p>

            <div className="bg-card rounded-2xl p-8 md:p-10 shadow-sm border border-border/40 space-y-8">
              {/* Intro */}
              <p className="text-foreground/80 leading-relaxed">
                MySabbat ("vi", "os", "vores") er en mobilapp, der hjælper unge med at planlægge deres næste periode. Vi beskytter dit privatliv og behandler dine personoplysninger i overensstemmelse med GDPR og dansk lovgivning.
              </p>

              {/* Section 1 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">1. Hvilke data indsamler vi?</h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground/80">
                  <li><strong>Kontooplysninger:</strong> Navn, e-mailadresse, adgangskode (krypteret).</li>
                  <li><strong>Brugsdata:</strong> Interaktioner i appen, device info.</li>
                  <li><strong>Autentificering:</strong> Login via Google/Apple.</li>
                  <li><strong>Personlighedstest:</strong> Vi gemmer svar og resultater for at personalisere indhold.</li>
                </ul>
              </section>

              {/* Section 2 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">2. Hvordan bruger vi dine data?</h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground/80">
                  <li>For at oprette og vedligeholde din konto.</li>
                  <li>For at personalisere indhold.</li>
                  <li>For at forbedre appen.</li>
                  <li>Vi sælger aldrig dine data.</li>
                </ul>
              </section>

              {/* Section 3 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">3. Hvem deler vi data med?</h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground/80">
                  <li>Tekniske samarbejdspartnere såsom Supabase og Lovable Cloud.</li>
                  <li>Alle partnere overholder GDPR.</li>
                </ul>
              </section>

              {/* Section 4 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">4. Dine rettigheder</h2>
                <p className="text-foreground/80 leading-relaxed mb-3">
                  Du har ret til indsigt, rettelse, sletning, dataportabilitet og indsigelse.
                </p>
                <p className="text-foreground/80 leading-relaxed">
                  Kontakt os på{" "}
                  <a href="mailto:info@mysabbat.dk" className="text-primary hover:underline">
                    info@mysabbat.dk
                  </a>
                </p>
              </section>

              {/* Section 5 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">5. Opbevaring</h2>
                <p className="text-foreground/80 leading-relaxed">
                  Data opbevares så længe du har en konto. Ved sletning slettes alt inden for 30 dage.
                </p>
              </section>

              {/* Section 6 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">6. Kontakt</h2>
                <p className="text-foreground/80 leading-relaxed">
                  MySabbat<br />
                  <a href="mailto:info@mysabbat.dk" className="text-primary hover:underline">
                    info@mysabbat.dk
                  </a>
                </p>
              </section>
            </div>
          </article>
        </div>
      </main>

      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Privacy;
